import Text from './Text'

// TODO This will become a separate component that shows the formatted text with line breaks etc.
// For now, it reuses the Text component.
export default Text